import { LockIcon } from '@phosphor-icons/react'
import React from 'react'

import { Icon } from '@/components/ui/icon'
import { routerFactory } from '@/factories'

import * as S from './navbar-menu.styled'
import { LockProps, NavbarLinkProps } from './navbar-menu.types'

export const NavbarLink = ({
  className,
  to,
  children,
  lock = false,
  size = 'medium',
}: NavbarLinkProps) => {
  const lockProps: LockProps = typeof lock !== 'boolean' ? lock : {}

  return (
    <S.NavLink
      className={className}
      to={routerFactory.getPathString(to)}
      $size={size}
      data-component-id="NavbarLink"
    >
      {Boolean(lock) && <Icon icon={LockIcon} {...lockProps} />}
      {children}
    </S.NavLink>
  )
}
